import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';
import { clientCookies } from 'utils/cookies';

import footerCookies from '../footerCookies';

const url = `${config.apiBasePath}/footer-data`;

export const RECEIVE_FOOTER_DATA = 'RECEIVE_FOOTER_DATA';
export const RECEIVE_FOOTER_DATA_ERROR = 'RECEIVE_FOOTER_DATA_ERROR';
export const SWITCH_TO_DESKTOP = 'SWITCH_TO_DESKTOP';
export const SWITCH_TO_MOBILE = 'SWITCH_TO_MOBILE';
export const PAGE_RELOADED = 'PAGE_RELOADED';

export function receiveFooterData(footerData) {
  return {
    type: RECEIVE_FOOTER_DATA,
    footerData,
  };
}

export function receiveFooterDataError(json) {
  return {
    type: RECEIVE_FOOTER_DATA_ERROR,
    error: json.error,
  };
}

export function fetchFooterData() {
  return (dispatch, store, { network }) => network
    .get(url)
    .then((data) => {
      dispatch(receiveFooterData(data));
    })
    .catch(err => {
      dispatch(receiveFooterDataError(err.data || UNKNOWN_ERROR));
    });
}

export function switchToDesktop() {
  return {
    type: SWITCH_TO_DESKTOP,
  };
}

export function setCookieAndReload() {
  clientCookies.set(footerCookies.STICK_TO_DESKTOP.name, '1', footerCookies.STICK_TO_DESKTOP.options);
  window.location.reload();
}

export function switchToMobile() {
  return {
    type: SWITCH_TO_MOBILE,
  };
}

export function removeCookieAndReload() {
  clientCookies.remove(footerCookies.STICK_TO_DESKTOP.name, { path: '/' });
  window.location.reload();
}

export function pageReloaded() {
  return {
    type: PAGE_RELOADED,
  };
}
